import React from 'react';
import uuid from 'uuid/v4';
import './App.css';

const STRAVA_AUTH_URL = 'https://www.strava.com/oauth/authorize'
const APP_CLIENT_ID = '40059';

const App: React.FC = () => {
  const nonce = uuid();
  const auth_url = [
    `${STRAVA_AUTH_URL}?client_id=${APP_CLIENT_ID}`,
    `redirect_uri=${process.env.PUBLIC_URL||'http://localhost:3000/'}`,
    'response_type=code',
    'scope=activity:read_all',
    `nonce=${nonce}`,
  ].join('&');
  return (
    <div>
      <header>
        <h1>Annual Stats</h1>
      </header>
      <main>
        <a className="button" href={auth_url}>Login</a>
      </main>
    </div>
  );
}

export default App;
